/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { AppResponse } from '../models';
// @ts-ignore
import { AppWithEnterpriseData } from '../models';
// @ts-ignore
import { AppsListResponse } from '../models';
// @ts-ignore
import { CreateAppRequest } from '../models';
// @ts-ignore
import { CreateAppWithEnterpriseRequest } from '../models';
// @ts-ignore
import { GenerateUploadSignedUrlRequest } from '../models';
// @ts-ignore
import { MagentoAppCreateRequest } from '../models';
// @ts-ignore
import { MagentoAppResponse } from '../models';
// @ts-ignore
import { SignedUrlDto } from '../models';
// @ts-ignore
import { UpdateAppRequest } from '../models';
/**
 * AppsApi - axios parameter creator
 * @export
 */
export const AppsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create App
         * @param {CreateAppRequest} createAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerCreate: async (createAppRequest: CreateAppRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAppRequest' is not null or undefined
            assertParamExists('appsControllerCreate', 'createAppRequest', createAppRequest)
            const localVarPath = `/v2/apps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAppRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create App with Enterprise Data
         * @param {CreateAppWithEnterpriseRequest} createAppWithEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerCreateAppWithEnterprise: async (createAppWithEnterpriseRequest: CreateAppWithEnterpriseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAppWithEnterpriseRequest' is not null or undefined
            assertParamExists('appsControllerCreateAppWithEnterprise', 'createAppWithEnterpriseRequest', createAppWithEnterpriseRequest)
            const localVarPath = `/v2/apps/with-enterprise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAppWithEnterpriseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create app and account for magento
         * @param {MagentoAppCreateRequest} magentoAppCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerCreateMagento: async (magentoAppCreateRequest: MagentoAppCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'magentoAppCreateRequest' is not null or undefined
            assertParamExists('appsControllerCreateMagento', 'magentoAppCreateRequest', magentoAppCreateRequest)
            const localVarPath = `/v2/apps/magento`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(magentoAppCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete App
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerDelete: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appsControllerDelete', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/apps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable App
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerDisable: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appsControllerDisable', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/apps/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable App
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerEnable: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appsControllerEnable', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/apps/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate upload signed urls
         * @param {string} gamixAppId 
         * @param {GenerateUploadSignedUrlRequest} generateUploadSignedUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerGenerateUploadSignedUrl: async (gamixAppId: string, generateUploadSignedUrlRequest: GenerateUploadSignedUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appsControllerGenerateUploadSignedUrl', 'gamixAppId', gamixAppId)
            // verify required parameter 'generateUploadSignedUrlRequest' is not null or undefined
            assertParamExists('appsControllerGenerateUploadSignedUrl', 'generateUploadSignedUrlRequest', generateUploadSignedUrlRequest)
            const localVarPath = `/v2/apps/signed-urls/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateUploadSignedUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get App
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appsControllerGet', 'id', id)
            const localVarPath = `/v2/apps/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get App
         * @param {string} identifier 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerGetByIdentifier: async (identifier: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identifier' is not null or undefined
            assertParamExists('appsControllerGetByIdentifier', 'identifier', identifier)
            const localVarPath = `/v2/apps/identifier/{identifier}`
                .replace(`{${"identifier"}}`, encodeURIComponent(String(identifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get App
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerGetDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appsControllerGetDetails', 'id', id)
            const localVarPath = `/v2/apps/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All Apps
         * @param {string} [search] 
         * @param {AppsControllerListTypeEnum} [type] 
         * @param {Array<AppsControllerListTypesEnum>} [types] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerList: async (search?: string, type?: AppsControllerListTypeEnum, types?: Array<AppsControllerListTypesEnum>, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/apps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (types) {
                localVarQueryParameter['types'] = types;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Migrate accounts to new structure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerMigrateAccounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/apps/migrate-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary propagate existing apps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerPropagate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/apps/propagate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update App
         * @param {string} gamixAppId 
         * @param {UpdateAppRequest} updateAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerUpdate: async (gamixAppId: string, updateAppRequest: UpdateAppRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('appsControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'updateAppRequest' is not null or undefined
            assertParamExists('appsControllerUpdate', 'updateAppRequest', updateAppRequest)
            const localVarPath = `/v2/apps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAppRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppsApi - functional programming interface
 * @export
 */
export const AppsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create App
         * @param {CreateAppRequest} createAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerCreate(createAppRequest: CreateAppRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerCreate(createAppRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create App with Enterprise Data
         * @param {CreateAppWithEnterpriseRequest} createAppWithEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerCreateAppWithEnterprise(createAppWithEnterpriseRequest: CreateAppWithEnterpriseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppWithEnterpriseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerCreateAppWithEnterprise(createAppWithEnterpriseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerCreateAppWithEnterprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create app and account for magento
         * @param {MagentoAppCreateRequest} magentoAppCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerCreateMagento(magentoAppCreateRequest: MagentoAppCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MagentoAppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerCreateMagento(magentoAppCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerCreateMagento']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete App
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerDelete(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerDelete(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disable App
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerDisable(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerDisable(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerDisable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Enable App
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerEnable(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerEnable(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerEnable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate upload signed urls
         * @param {string} gamixAppId 
         * @param {GenerateUploadSignedUrlRequest} generateUploadSignedUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerGenerateUploadSignedUrl(gamixAppId: string, generateUploadSignedUrlRequest: GenerateUploadSignedUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignedUrlDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerGenerateUploadSignedUrl(gamixAppId, generateUploadSignedUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerGenerateUploadSignedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get App
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get App
         * @param {string} identifier 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerGetByIdentifier(identifier: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerGetByIdentifier(identifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerGetByIdentifier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get App
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerGetDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerGetDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerGetDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All Apps
         * @param {string} [search] 
         * @param {AppsControllerListTypeEnum} [type] 
         * @param {Array<AppsControllerListTypesEnum>} [types] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerList(search?: string, type?: AppsControllerListTypeEnum, types?: Array<AppsControllerListTypesEnum>, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerList(search, type, types, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Migrate accounts to new structure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerMigrateAccounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerMigrateAccounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerMigrateAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary propagate existing apps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerPropagate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerPropagate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerPropagate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update App
         * @param {string} gamixAppId 
         * @param {UpdateAppRequest} updateAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appsControllerUpdate(gamixAppId: string, updateAppRequest: UpdateAppRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appsControllerUpdate(gamixAppId, updateAppRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppsApi.appsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppsApi - factory interface
 * @export
 */
export const AppsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create App
         * @param {AppsApiAppsControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerCreate(requestParameters: AppsApiAppsControllerCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppResponse> {
            return localVarFp.appsControllerCreate(requestParameters.createAppRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create App with Enterprise Data
         * @param {AppsApiAppsControllerCreateAppWithEnterpriseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerCreateAppWithEnterprise(requestParameters: AppsApiAppsControllerCreateAppWithEnterpriseRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppWithEnterpriseData> {
            return localVarFp.appsControllerCreateAppWithEnterprise(requestParameters.createAppWithEnterpriseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create app and account for magento
         * @param {AppsApiAppsControllerCreateMagentoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerCreateMagento(requestParameters: AppsApiAppsControllerCreateMagentoRequest, options?: RawAxiosRequestConfig): AxiosPromise<MagentoAppResponse> {
            return localVarFp.appsControllerCreateMagento(requestParameters.magentoAppCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete App
         * @param {AppsApiAppsControllerDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerDelete(requestParameters: AppsApiAppsControllerDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.appsControllerDelete(requestParameters.gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable App
         * @param {AppsApiAppsControllerDisableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerDisable(requestParameters: AppsApiAppsControllerDisableRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppResponse> {
            return localVarFp.appsControllerDisable(requestParameters.gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable App
         * @param {AppsApiAppsControllerEnableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerEnable(requestParameters: AppsApiAppsControllerEnableRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppResponse> {
            return localVarFp.appsControllerEnable(requestParameters.gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate upload signed urls
         * @param {AppsApiAppsControllerGenerateUploadSignedUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerGenerateUploadSignedUrl(requestParameters: AppsApiAppsControllerGenerateUploadSignedUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignedUrlDto> {
            return localVarFp.appsControllerGenerateUploadSignedUrl(requestParameters.gamixAppId, requestParameters.generateUploadSignedUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get App
         * @param {AppsApiAppsControllerGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerGet(requestParameters: AppsApiAppsControllerGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppResponse> {
            return localVarFp.appsControllerGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get App
         * @param {AppsApiAppsControllerGetByIdentifierRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerGetByIdentifier(requestParameters: AppsApiAppsControllerGetByIdentifierRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppResponse> {
            return localVarFp.appsControllerGetByIdentifier(requestParameters.identifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get App
         * @param {AppsApiAppsControllerGetDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerGetDetails(requestParameters: AppsApiAppsControllerGetDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppResponse> {
            return localVarFp.appsControllerGetDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All Apps
         * @param {AppsApiAppsControllerListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerList(requestParameters: AppsApiAppsControllerListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AppsListResponse> {
            return localVarFp.appsControllerList(requestParameters.search, requestParameters.type, requestParameters.types, requestParameters.limit, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Migrate accounts to new structure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerMigrateAccounts(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.appsControllerMigrateAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary propagate existing apps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerPropagate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.appsControllerPropagate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update App
         * @param {AppsApiAppsControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appsControllerUpdate(requestParameters: AppsApiAppsControllerUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppResponse> {
            return localVarFp.appsControllerUpdate(requestParameters.gamixAppId, requestParameters.updateAppRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for appsControllerCreate operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerCreateRequest
 */
export interface AppsApiAppsControllerCreateRequest {
    /**
     * 
     * @type {CreateAppRequest}
     * @memberof AppsApiAppsControllerCreate
     */
    readonly createAppRequest: CreateAppRequest
}

/**
 * Request parameters for appsControllerCreateAppWithEnterprise operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerCreateAppWithEnterpriseRequest
 */
export interface AppsApiAppsControllerCreateAppWithEnterpriseRequest {
    /**
     * 
     * @type {CreateAppWithEnterpriseRequest}
     * @memberof AppsApiAppsControllerCreateAppWithEnterprise
     */
    readonly createAppWithEnterpriseRequest: CreateAppWithEnterpriseRequest
}

/**
 * Request parameters for appsControllerCreateMagento operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerCreateMagentoRequest
 */
export interface AppsApiAppsControllerCreateMagentoRequest {
    /**
     * 
     * @type {MagentoAppCreateRequest}
     * @memberof AppsApiAppsControllerCreateMagento
     */
    readonly magentoAppCreateRequest: MagentoAppCreateRequest
}

/**
 * Request parameters for appsControllerDelete operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerDeleteRequest
 */
export interface AppsApiAppsControllerDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AppsApiAppsControllerDelete
     */
    readonly gamixAppId: string
}

/**
 * Request parameters for appsControllerDisable operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerDisableRequest
 */
export interface AppsApiAppsControllerDisableRequest {
    /**
     * 
     * @type {string}
     * @memberof AppsApiAppsControllerDisable
     */
    readonly gamixAppId: string
}

/**
 * Request parameters for appsControllerEnable operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerEnableRequest
 */
export interface AppsApiAppsControllerEnableRequest {
    /**
     * 
     * @type {string}
     * @memberof AppsApiAppsControllerEnable
     */
    readonly gamixAppId: string
}

/**
 * Request parameters for appsControllerGenerateUploadSignedUrl operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerGenerateUploadSignedUrlRequest
 */
export interface AppsApiAppsControllerGenerateUploadSignedUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof AppsApiAppsControllerGenerateUploadSignedUrl
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {GenerateUploadSignedUrlRequest}
     * @memberof AppsApiAppsControllerGenerateUploadSignedUrl
     */
    readonly generateUploadSignedUrlRequest: GenerateUploadSignedUrlRequest
}

/**
 * Request parameters for appsControllerGet operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerGetRequest
 */
export interface AppsApiAppsControllerGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AppsApiAppsControllerGet
     */
    readonly id: string
}

/**
 * Request parameters for appsControllerGetByIdentifier operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerGetByIdentifierRequest
 */
export interface AppsApiAppsControllerGetByIdentifierRequest {
    /**
     * 
     * @type {string}
     * @memberof AppsApiAppsControllerGetByIdentifier
     */
    readonly identifier: string
}

/**
 * Request parameters for appsControllerGetDetails operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerGetDetailsRequest
 */
export interface AppsApiAppsControllerGetDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof AppsApiAppsControllerGetDetails
     */
    readonly id: string
}

/**
 * Request parameters for appsControllerList operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerListRequest
 */
export interface AppsApiAppsControllerListRequest {
    /**
     * 
     * @type {string}
     * @memberof AppsApiAppsControllerList
     */
    readonly search?: string

    /**
     * 
     * @type {'coreLoyalty' | 'coreTeams' | 'corePilot' | 'POS' | 'fisico' | 'games' | 'advertiser' | 'retailer'}
     * @memberof AppsApiAppsControllerList
     */
    readonly type?: AppsControllerListTypeEnum

    /**
     * 
     * @type {Array<'coreLoyalty' | 'coreTeams' | 'corePilot' | 'POS' | 'fisico' | 'games' | 'advertiser' | 'retailer'>}
     * @memberof AppsApiAppsControllerList
     */
    readonly types?: Array<AppsControllerListTypesEnum>

    /**
     * 
     * @type {number}
     * @memberof AppsApiAppsControllerList
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof AppsApiAppsControllerList
     */
    readonly skip?: number
}

/**
 * Request parameters for appsControllerUpdate operation in AppsApi.
 * @export
 * @interface AppsApiAppsControllerUpdateRequest
 */
export interface AppsApiAppsControllerUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AppsApiAppsControllerUpdate
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {UpdateAppRequest}
     * @memberof AppsApiAppsControllerUpdate
     */
    readonly updateAppRequest: UpdateAppRequest
}

/**
 * AppsApi - object-oriented interface
 * @export
 * @class AppsApi
 * @extends {BaseAPI}
 */
export class AppsApi extends BaseAPI {
    /**
     * 
     * @summary Create App
     * @param {AppsApiAppsControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerCreate(requestParameters: AppsApiAppsControllerCreateRequest, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerCreate(requestParameters.createAppRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create App with Enterprise Data
     * @param {AppsApiAppsControllerCreateAppWithEnterpriseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerCreateAppWithEnterprise(requestParameters: AppsApiAppsControllerCreateAppWithEnterpriseRequest, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerCreateAppWithEnterprise(requestParameters.createAppWithEnterpriseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create app and account for magento
     * @param {AppsApiAppsControllerCreateMagentoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerCreateMagento(requestParameters: AppsApiAppsControllerCreateMagentoRequest, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerCreateMagento(requestParameters.magentoAppCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete App
     * @param {AppsApiAppsControllerDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerDelete(requestParameters: AppsApiAppsControllerDeleteRequest, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerDelete(requestParameters.gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable App
     * @param {AppsApiAppsControllerDisableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerDisable(requestParameters: AppsApiAppsControllerDisableRequest, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerDisable(requestParameters.gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable App
     * @param {AppsApiAppsControllerEnableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerEnable(requestParameters: AppsApiAppsControllerEnableRequest, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerEnable(requestParameters.gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate upload signed urls
     * @param {AppsApiAppsControllerGenerateUploadSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerGenerateUploadSignedUrl(requestParameters: AppsApiAppsControllerGenerateUploadSignedUrlRequest, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerGenerateUploadSignedUrl(requestParameters.gamixAppId, requestParameters.generateUploadSignedUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get App
     * @param {AppsApiAppsControllerGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerGet(requestParameters: AppsApiAppsControllerGetRequest, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get App
     * @param {AppsApiAppsControllerGetByIdentifierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerGetByIdentifier(requestParameters: AppsApiAppsControllerGetByIdentifierRequest, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerGetByIdentifier(requestParameters.identifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get App
     * @param {AppsApiAppsControllerGetDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerGetDetails(requestParameters: AppsApiAppsControllerGetDetailsRequest, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerGetDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All Apps
     * @param {AppsApiAppsControllerListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerList(requestParameters: AppsApiAppsControllerListRequest = {}, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerList(requestParameters.search, requestParameters.type, requestParameters.types, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Migrate accounts to new structure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerMigrateAccounts(options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerMigrateAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary propagate existing apps
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerPropagate(options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerPropagate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update App
     * @param {AppsApiAppsControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppsApi
     */
    public appsControllerUpdate(requestParameters: AppsApiAppsControllerUpdateRequest, options?: RawAxiosRequestConfig) {
        return AppsApiFp(this.configuration).appsControllerUpdate(requestParameters.gamixAppId, requestParameters.updateAppRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AppsControllerListTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    CorePilot: 'corePilot',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;
export type AppsControllerListTypeEnum = typeof AppsControllerListTypeEnum[keyof typeof AppsControllerListTypeEnum];
/**
 * @export
 */
export const AppsControllerListTypesEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    CorePilot: 'corePilot',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;
export type AppsControllerListTypesEnum = typeof AppsControllerListTypesEnum[keyof typeof AppsControllerListTypesEnum];
